import BlogPageLayout from "./BlogPageLayout";

const ArticuloAhorro = () => {
  return (
    <BlogPageLayout
      titulo="la importancias de saber css"
      autor="Samuel Zavala"
      fecha="12 de marzo de 2026"
      articulo='true'
    >
      <article className="col-10 col-md-8">
        <p>Contenido del artículo...</p>
      </article>
    </BlogPageLayout>
  );
};

export default ArticuloAhorro;